"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.collectDataFromDataset = void 0;
function collectDataFromDataset(element, key, recursive) {
    if (recursive === void 0) { recursive = true; }
    if (!element) {
        return;
    }
    if (element instanceof HTMLElement) {
        var dataset = element.dataset;
        var data = void 0;
        var value = dataset[key];
        if (value) {
            try {
                var parsed = JSON.parse(value);
                data = __assign(__assign({}, data), parsed);
            }
            catch (error) {
                //
            }
        }
        if (data) {
            return data;
        }
        if (!data && recursive && element.parentElement) {
            return collectDataFromDataset(element.parentElement, key);
        }
    }
}
exports.collectDataFromDataset = collectDataFromDataset;
